import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ContactService } from '../../../services/contact.service';
import { MetaService } from '../../../services/meta.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  imageUrl!: string;
  contentTitle = 'Contact Us - XipeTech';
  contentDescription = 'Welcome to XipeTech, We provide the most responsive and functional IT Services. Invest your money in Developing a Brand, not just a website';
  contentKeywords = 'Technology Software, Web Development, API integration, PHP Development, Next.js development, React.js development, Node.js development, CMS Development, MVC Development, Android Application, iPhone Application, UI/UX Designing, UI Designing, 3D Designing, Logo Designing, Cloud computing, Artificial intelligence, Data analytics, Cybersecurity, Web development, Mobile app development, IT consulting, Virtual reality, Augmented reality, Web design Website development, Front-end development, Back-end development, Full-stack development, Responsive design, User interface (UI), User experience (UX), Custom web development, E-commerce development, Laravel development, Yii development, Codeigniter development, Content management systems (CMS), WordPress development, Drupal development, Magento development, Shopify development, Mobile-friendly websites, Cross-browser compatibility, Web application development, API integration, Website maintenance';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  showForm = false;
  contactForm: FormGroup;
  resumeFile: File | null = null;
  successMessage: string = '';
  errorMessage: string = '';
  submitAttempted = false;
  isLoading = false;
  siteKey = environment.recaptcha.siteKey;
  captchaResponse: string | null = null;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private contactService: ContactService,
    private metaService: MetaService,
    private router: Router,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }

  executeCaptcha() {
    this.recaptchaV3Service.execute('contactForm')
      .subscribe((token: string) => {
        this.captchaResponse = token;
        console.log('Captcha token:', token);
      });
  }

  onSubmit(): void {

    this.submitAttempted = true;
    this.successMessage = '';
    this.errorMessage = '';

    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.executeCaptcha();

    const formData = new FormData();
    formData.append('name', this.contactForm.get('name')?.value);
    formData.append('email', this.contactForm.get('email')?.value);
    formData.append('phone', this.contactForm.get('phone')?.value);
    formData.append('subject', this.contactForm.get('subject')?.value);
    formData.append('message', this.contactForm.get('message')?.value);
    formData.append('captcha', this.captchaResponse ?? '');

    this.isLoading = true;

    this.contactService.contactUs(formData).subscribe({
      next: (res) => {
        this.successMessage = res.message ?? 'Your query has been submitted successfully!';
        this.errorMessage = '';
        this.contactForm.reset();
        this.showForm = false;
        this.isLoading = false;
        this.resumeFile = null;
        this.submitAttempted = false;
      },
      error: (err) => {
        console.error('Contact Us form failed:', err);
        this.isLoading = false;
        this.errorMessage = err.message ?? 'Failed to submit. Please try again.';
        this.successMessage = '';
      }
    });
  }

  onlyNumbers(event: any): void {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // Helper method to check if field has error
  hasError(fieldName: string): boolean {
    const field = this.contactForm.get(fieldName);
    return !!(field?.invalid && (field?.touched || this.submitAttempted));
  }

  // Get error message for specific field
  getErrorMessage(fieldName: string): string {
    const field = this.contactForm.get(fieldName);
    if (field?.errors?.['required']) {
      return 'This field is required';
    } else if (field?.errors?.['email']) {
      return 'Please enter a valid email address';
    } else if (field?.errors?.['maxlength']) {
      return `Maximum length exceeded`;
    }

    return '';
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/noimage.png';
  }
}
